import { toast } from "react-hot-toast";
import { bookEndpoints,issuedBookendpoints } from "../apis";
import { apiConnector } from "../apiconnector";
import { useSelector } from "react-redux";
import { setCourseCategories } from "../../redux/slices/categorySlice";
import Swal from "sweetalert2";

const {
  CREATE_BOOK_API,
  GET_ALL_BOOK_API,
  GET_ALL_CATEGORY_API,
  CREATE_CATEGORY_API,
  CATEGORYPAGEDATA_API,
  ISSUED_BOOK_API,
  RETURN_ISSUED_BOOK_API,
} = bookEndpoints;

const {
  GET_ALL_ISSUED_BOOK_API,
  GET_ALL_ISSUED_BOOK_REPORT_API
} = issuedBookendpoints;

export const addNewBook = async (data, token) => {
  let result = null;
  const toastId = toast.loading("Loading...");
  // console.log(data)
  try {
    const response = await apiConnector("POST", CREATE_BOOK_API, data, {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    });
    console.log("CREATE BOOK API RESPONSE............", response);
    if (!response?.data?.success) {
      throw new Error("Could Not Add Book Details");
    }
    toast.success("Book Details Added Successfully");
    result = response?.data?.data;
  } catch (error) {
    console.log("CREATE Book API ERROR............", error);
    toast.error(error.message);
  }
  toast.dismiss(toastId);
  return result;
};

export const getAllBook = async () => {
  const toastId = toast.loading("Loading...");
  let result = [];
  try {
    const response = await apiConnector("GET", GET_ALL_BOOK_API);
    if (!response?.data?.success) {
      throw new Error("Could Not Fetch Books Categories");
    }
    result = response?.data?.data;
  } catch (error) {
    console.log("GET_ALL_BOOK_API API ERROR............", error);
    toast.error(error.message);
  }
  toast.dismiss(toastId);
  return result;
};

export const fetchBokCategories = async () => {
  let result = [];
  try {
    const response = await apiConnector("GET", GET_ALL_CATEGORY_API);
    //   console.log("GET_ALL_CATEGORY_API API RESPONSE............", response)
    if (!response?.data?.success) {
      throw new Error("Could Not Fetch Bool Categories");
    }
    result = response?.data?.data;
  } catch (error) {
    console.log("GET_ALL_CATEGORY_API API ERROR............", error);
    toast.error(error.message);
  }
  return result;
};

export const createCetegory = async (name, token) => {
  const toastId = toast.loading("Loading...");

  try {
    const response = await apiConnector(
      "POST",
      CREATE_CATEGORY_API,
      {
        name,
      },
      {
        // "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      }
    );
    console.log("CREATE BOOK API RESPONSE............", response);
    if (!response?.data?.success) {
      throw new Error("Could Not Add Cetegory Details");
    }
    toast.success("Cetegory Details Added Successfully");
  } catch (error) {
    console.log("CREATE Cetegory API ERROR............", error);
    toast.error(error.message);
  }
  toast.dismiss(toastId);
  return;
};

export const getCatalogPageData = async (categoryId) => {
  const toastId = toast.loading("Loading...");
  let result = [];
  try {
    const response = await apiConnector("POST", CATEGORYPAGEDATA_API, {
      categoryId: categoryId,
    });
    if (!response?.data?.success) {
      throw new Error("Could Not Fetch Catagory page data.");
    }
    result = response?.data;
  } catch (error) {
    console.log("CATEGORYPAGEDATA_API API ERROR............", error);
    toast.error(error.message);
    result = error.response?.data;
  }
  toast.dismiss(toastId);
  return result;
};

export const issuedBookF = async (data, token) => {
  const toastId = toast.loading("Loading...");

  try {
    const response = await apiConnector("POST", ISSUED_BOOK_API, data, {
      // "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    });
    console.log("ISSUED API RESPONSE............", response);
    if (!response?.data?.success) {
      Swal.fire({
        title: "Oops",
        text: `${response?.data.message}`,
        icon: "error",
      });
      throw new Error("Cannot Issued book ");
    }
    toast.success("Issued book  Successfully");
    Swal.fire({
      title: `Issued Book 
      Student Name ${
        response.data.data.studentDetails.firstName +
        " " +
        response.data.data.studentDetails.lastName
      }`,
      text: `Best Of luck`,
      icon: "success",
    });
  } catch (error) {
    // console.log("ISSUED BOOK API ERROR............", error)
    toast.error(error.response.data.message);
    Swal.fire({
      title: "Oops",
      text: `${error.response.data.message}`,
      icon: "error",
    });
  }
  toast.dismiss(toastId);
  return;
};

export const returnIssuedBook = async (data, token) => {
  // const toastId = toast.loading("Loading...")

  try {
    const response = await apiConnector("POST", RETURN_ISSUED_BOOK_API, data, {
      // "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    });
    console.log("RETURN ISSUED API RESPONSE............", response);
    console.log(response.data)
    console.log(response.data.success)

    if (!response?.data?.success) {
      Swal.fire({
        title: "Oops",
        text: `${response?.data.message}`,
        icon: "error",
      });
      throw new Error("Cannot RETURN Issued book ");
    }
    console.log(response.data.data);

    // Assuming response.data.data.bookIssuedDate and response.data.data.bookRetunDate are ISO 8601 strings
    const issuedDate = new Date(response.data.data.bookIssuedDate);
    const returnDate = new Date(response.data.data.bookRetunDate);

    // Format dates
    const formattedIssuedDate = issuedDate.toLocaleDateString("en-US");
    const formattedReturnDate = returnDate.toLocaleDateString("en-US");

    // Display the formatted dates using Swal.fire
    Swal.fire({
      title: `Return Book 
          Student Name  ${
            response.data.data.studentDetails.firstName +
            " " +
            response.data.data.studentDetails.lastName
          }`,
      text: `Issue Date ${formattedIssuedDate}, return Date ${formattedReturnDate} Fine ${response.data.data.lateFine} Rs.`,
      icon: "success",
    });

    // toast.success(" RETURN  book  Successfully")
  } catch (error) {
    console.log("RETURN ISSUED BOOK API ERROR............", error);
    // toast.error(error.response.data.message)
    Swal.fire({
      title: "Oops",
      text: `${error.response.data.message}`,
      icon: "error",
    });
  }
  // toast.dismiss(toastId)
  return;
};


export const getAllIssue = async(page,limit,token) =>{
  let result = null;
  try{
    const response = await apiConnector( "GET",
    `${GET_ALL_ISSUED_BOOK_API}?page=${page}&limit=${limit}`,
    null,
    {
    // "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    }
    );

    if (!response.data.success) {
      throw new Error(response.data.message)
    }
    result = response
  
 
  //   dispatch(setLoading(false));
  }catch(err){
    console.log("fethiing getAllIssued book error")
    console.log(err)
  }
  return result

}


export const getAllIssueBookReport = async(page,limit,token) =>{
  let result = null;
  try{
    const response = await apiConnector( "GET",
    `${GET_ALL_ISSUED_BOOK_REPORT_API}?page=${page}&limit=${limit}`,
    null,
    {
    // "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    }
    );

    if (!response.data.success) {
      throw new Error(response.data.message)
    }
    result = response
  
 
  //   dispatch(setLoading(false));
  }catch(err){
    console.log("fethiing getAllIssued book error")
    console.log(err)
  }
  return result

}